import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';
import isNull from 'lodash/isNull';

export const TITLE_COLUMN = '';

// helpers
export const getDate = answer => new Date(get(answer, 'answerDate'));
export const isTitleColumn = colName => colName === TITLE_COLUMN;
export const makeString = len => {
  let str = TITLE_COLUMN;

  for (let i = 0; i < len; i++) {
    str += ' ';
  }

  return str;
};

// filters
export const getFilteredColumns = (cols, id) =>
  isNull(id) ? cols : cols.filter(col => isTitleColumn(col) || col.id === id);

// sorters
export const sortByNewest = (a, b) => getDate(a) - getDate(b);

export const sortColumns = (a, b) => {
  if (!isPlainObject(a)) return 1;
  if (!isPlainObject(b)) return -1;

  return isPlainObject(a) && isPlainObject(b) ? sortByNewest(a, b) : 0;
};

export const getSortedColumns = columns => {
  const sortedByDate = Object.keys(columns)
    .map(key => {
      const column = columns[key];

      return column.value ? { ...column, id: key } : key;
    })
    .sort(sortColumns);

  const firstColIndex = sortedByDate.findIndex(item => isTitleColumn(item));

  if (firstColIndex > -1) {
    const firslCol = sortedByDate[firstColIndex];
    sortedByDate.splice(firstColIndex, 1);
    sortedByDate.unshift(firslCol);
  }

  return sortedByDate;
};



// WEBPACK FOOTER //
// ./src/components/Survey/helpers/sorting.js